import { useEffect } from 'react';

import { setPersistedLocale } from '../persistedLocale';

import { useCurrentLocale } from './selectors';

export const usePersistLocale = (): void => {
  const locale = useCurrentLocale();

  useEffect(() => {
    setPersistedLocale(locale);
  }, [locale]);
};
